module.exports = __webpack_public_path__ + "images/category_lp/earphone/new/mainView-pc_d04a649fc2e648e9847668566d338b1c.png";